// @flow
import * as React from 'react';
import moment from 'moment';

import "core-js/stable";
import "regenerator-runtime/runtime";

import * as API from './api';
import AdultInformation from './components/AdultInformation/AdultInformation';
import Agreement from './components/Agreement/Agreement';
import ChildInformation from './components/ChildInformation/ChildInformation';
import Completed from './components/Completed/Completed';
import HearAbout from './components/HearAbout/HearAbout';
import LocationSelection from './components/LocationSelection/LocationSelection';
// import { loadReCaptcha } from 'react-recaptcha-v3';

import { renderToStaticMarkup } from 'react-dom/server';
import { withLocalize, Translate, getActiveLanguage  } from "react-localize-redux";
import englishTranslations from "./translations/en.translations.json";
import spanishTranslations from "./translations/es.translations.json";

import { addCustomTagEvent } from './utilities/customTag';

import './OnlineWaiver.css';
import LanguageToggle from './translations/LanguageToggle/LanguageToggle';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { defaultCountry } from './helpers';
import getCountryNameFromCode from './components/CountrySelect/CountryCodeMap'

export type gender = 'Male' | 'Female' | 'Other' | '';

const preFilled = false;

let toastSuccessId = undefined;

export interface IChildInfo {
    firstName: string;
    lastName: string;
    preferredName: string;
    dateOfBirth: moment;
    gender: gender;
};

const WaiverPage = Object.freeze({
    AdultInformation: 0,
    ChildInformation: 1,
    LocationSelection: 2,
    HearAbout: 3,
    Agreement: 4,
    Completed: 5,
});

export interface IOnlineWaiverState {
    currentPage: number,
    firstName: string,
    lastName: string,
    preferredName: string,
    email: string,
    phone: string,
    gender: gender,
    dateOfBirth: moment,
    yearOfBirth: number,
    monthOfBirth: number,
    dayOfBirth: number,
    adultYearOfBirthTried: boolean,
    adultMonthOfBirthTried: boolean,
    adultDayOfBirthTried: boolean,
    address: string,
    city: string,
    provinceState: string,
    country: string,
    postalZipCode: string,
    signForChildren: string,
    childInfos: IChildInfo[],
    location: number,
    hearAbout: string[],
    otherEntry: string,
    checkedTerms: boolean,
    checkedRules: boolean,
    checkedRelease: boolean,
    checkedNewsletter: boolean,
    checkedSmsOptIn: Boolean,
    checkedCovid: boolean,
    version: string,

    locationsData: API.Dictionary<API.ILocationData>,
    hearAboutData: API.IHearAboutData[],

    captchaCompleted: boolean,
};


class OnlineWaiver extends React.Component<any, IOnlineWaiverState> {
    waitingForNext: boolean;

    constructor(props) {
        super(props);

        this.props.initialize({
            languages: [
                { name: "English", code: "en" },
                { name: "Español", code: "es" },
            ],
            options: {
                renderToStaticMarkup
            }
        })

        this.state = {
            currentPage: WaiverPage.AdultInformation,
            firstName: (preFilled) ? 'George' : '',
            lastName: (preFilled) ? 'Foobario' : '',
            preferredName: (preFilled) ? 'George' : '',
            email: (preFilled) ? 'developer@ctrlv.ca' : '',
            phone: (preFilled) ? '(519) 741-1234' : '',
            gender: (preFilled) ? 'Male' : '',
            dateOfBirth: (preFilled) ? new moment("1996-12-31", "YYYY-MM-DD") : new moment(),
            dayOfBirth: (preFilled) ? 0 : new moment().date(),
            monthOfBirth: (preFilled) ? 0 : new moment().month(),
            yearOfBirth: (preFilled) ? 2019 : new moment().year(),
            address: (preFilled) ? '1 Test Ave' : '',
            city: (preFilled) ? 'Waterloo' : '',
            provinceState: (preFilled) ? 'Ontario' : '',
            country: (preFilled) ? 'Canada' : getCountryNameFromCode(defaultCountry()),
            postalZipCode: (preFilled) ? 'N2L1N1' : '',
            signForChildren: (preFilled) ? 'Myself' : '',
            childInfos: [{
                firstName: '',
                lastName: '',
                preferredName: '',
                dateOfBirth: new moment(),
                gender: ''
            }],
            location: (preFilled) ? 1 : -1,
            hearAbout: (preFilled) ? ['Google'] : [],
            otherEntry: (preFilled) ? '' : '',
            checkedTerms: (preFilled) ? true : false,
            checkedRules: (preFilled) ? true : false,
            checkedRelease: (preFilled) ? true : false,
            checkedNewsletter: (preFilled) ? true : false,
            checkedSmsOptIn: (preFilled) ? true : false,
            checkedCovid: true,
            version: '1.2.0',

            adultYearOfBirthTried: false,
            adultMonthOfBirthTried: false,
            adultDayOfBirthTried: false,

            locationsData: {},
            hearAboutData: [],

            captchaCompleted: false,
            recaptcha: ''
        };

        this.props.addTranslationForLanguage(englishTranslations, "en");
        this.props.addTranslationForLanguage(spanishTranslations, "es");

        this.waitingForNext = false;
    };

    updateFirstName = (value: string) => {
        this.setState({ firstName: value });
    };

    updateLastName = (value: string) => {
        this.setState({ lastName: value });
    };

    updatePreferredName = (value: string) => {
        this.setState({ preferredName: value });
    };

    updateEmail = (value: string) => {
        this.setState({ email: value });
    };

    updatePhone = (value: string) => {
        this.setState({ phone: value });
    };

    updateGender = (value: gender) => {
        this.setState({ gender: value });
    };

    updateDateOfBirth = (value: moment) => {
        if (value !== undefined && value !== null && value instanceof moment)
            this.setState({ dateOfBirth: value });
    };

    updateAddress = (value: string) => {
        this.setState({ address: value });
    };

    updateCity = (value: string) => {
        this.setState({ city: value });
    };

    updateProvinceState = (value: string) => {
        if (this.state.provinceState !== value) {
            this.setState({
                city: ''
            });
        }
        this.setState({ provinceState: value });
    };

    updateCountry = (value: string) => {
        if (this.state.country !== value) {
            this.setState({
                provinceState: '',
                city: ''
            });
        }
        this.setState({ country: value });
    };

    updatePostalZipCode = (value: string) => {
        this.setState({ postalZipCode: value });
    };

    updateSignForChildren = (value: string) => {
        this.setState({ signForChildren: value });
    };

    updateChildrenInfo = (value: IChildInfo[]) => {
        this.setState({ childInfos: value });
    };

    updateLocation = (value: number) => {
        this.setState({ location: value, hearAbout: [] });
    };

    updateHearAbout = (value: string[]) => {
        this.setState({ hearAbout: value });
    };

    updateOtherEntry = (value: string) => {
        this.setState({ otherEntry: value });
    };

    updateCheckTerms = (value: boolean) => {
        this.setState({ checkedTerms: value });
    };

    updateCheckRules = (value: boolean) => {
        this.setState({ checkedRules: value });
    };

    updateCheckRelease = (value: boolean) => {
        this.setState({ checkedRelease: value });
    };

    updateCheckNewsletter = (value: boolean) => {
        this.setState({ checkedNewsletter: value });
    };

    updateCheckSmsOptIn = (value: boolean) => {
        this.setState({ checkedSmsOptIn: value });
    };

    updateYearOfBirthTried = (value: boolean) => {
        this.setState({ adultYearOfBirthTried: value });
    };

    updateMonthOfBirthTried = (value: boolean) => {
        this.setState({ adultMonthOfBirthTried: value });
    };

    updateDayOfBirthTried = (value: boolean) => {
        this.setState({ adultDayOfBirthTried: value });
    };

    updateReCaptcha = (recaptchaToken: string) => {
        this.setState({
            recaptcha: recaptchaToken,
        })
    }

    onClickNext = () => {
        if (this.waitingForNext === false) {
            this.waitingForNext = true;
            let nextPage = this.state.currentPage + 1;

            // Skip child info if necessary
            if (this.state.currentPage === WaiverPage.AdultInformation && this.state.signForChildren === 'Myself') {
                nextPage = WaiverPage.LocationSelection;
            }
            // Fetch location info, only if necessary
            if (nextPage === WaiverPage.LocationSelection && Object.keys(this.state.locationsData).length === 0) {
                API.getLocations()
                    .then((locationsData) => {
                        this.setState({
                            locationsData: locationsData,
                            currentPage: nextPage
                        }, () => {
                            this.waitingForNext = false;
                        });
                    })
                    .catch((error) => {
                        console.error(error);
                        this.waitingForNext = false;
                    });
            }
            // Fetch hear about info
            else if (nextPage === WaiverPage.HearAbout) {
                API.getHearAboutData(this.state.location)
                    .then((hearAboutData) => {
                        this.setState({
                            hearAboutData: hearAboutData,
                            currentPage: nextPage
                        }, () => {
                            this.waitingForNext = false;
                        });
                    })
                    .catch((error) => {
                        console.error(error);
                        this.waitingForNext = false;
                    });
            }
            else if (nextPage === WaiverPage.Completed) {
                console.log('Calling Submit Data.');
                this.submitWaiverData(nextPage);
            }
            else {
                this.setState({
                    currentPage: nextPage
                }, () => {
                    this.waitingForNext = false;
                });
            }
        }
    };

    submitWaiverData = async function (nextPage) {
        try {
            var tempState = this.state
            tempState.languageCode = getActiveLanguage(this.props).code
            const result = await API.submitWaiverData(tempState);

            console.log(`Submission result: ${result}`);
            if (result === undefined) {
                toast.warn(<Translate id="online_waiver_js.warning_submitting"/>, {
                    autoClose: false,
                    position:  toast.POSITION.BOTTOM_CENTER
                 });
            } else {
                toastSuccessId = toast.success(<Translate id="online_waiver_js.waiver_success"/>, {
                    autoClose: false,
                    position:  toast.POSITION.BOTTOM_CENTER
                 });
            }
            this.setState({
                currentPage: nextPage
            }, () => {
                this.waitingForNext = false;
            });
        } catch (err) {
            console.error(err);
            toast.error(<Translate id="online_waiver_js.failure_submitting"/>, {
                autoClose:  false,
                position:  toast.POSITION.BOTTOM_CENTER
             });
            this.waitingForNext = false;
        }
    }

    onClickBack = () => {
        if (this.state.currentPage > 0) {
            let targetPage = this.state.currentPage - 1;
            if (targetPage === WaiverPage.ChildInformation && this.state.signForChildren === 'Myself') {
                targetPage = WaiverPage.AdultInformation;
            }
            this.setState({
                currentPage: targetPage
            });
        }
    };

    getPage() {
        switch (this.state.currentPage) {
            case WaiverPage.AdultInformation:
                if (toastSuccessId !== undefined) {
                    toast.dismiss(toastSuccessId);
                    toastSuccessId = undefined;
                }
                addCustomTagEvent({
                    event: 'pageView',
                    page: {
                        path: "/waiver/AdultInformation"
                    }
                });
                return (
                    <AdultInformation
                        firstName={this.state.firstName}
                        lastName={this.state.lastName}
                        preferredName={this.state.preferredName}
                        email={this.state.email}
                        phone={this.state.phone}
                        gender={this.state.gender}
                        dateOfBirth={this.state.dateOfBirth}
                        address={this.state.address}
                        city={this.state.city}
                        provinceState={this.state.provinceState}
                        country={this.state.country}
                        postalZipCode={this.state.postalZipCode}
                        signForChildren={this.state.signForChildren}
                        updateFirstName={this.updateFirstName}
                        updateLastName={this.updateLastName}
                        updatePreferredName={this.updatePreferredName}
                        updateEmail={this.updateEmail}
                        updatePhone={this.updatePhone}
                        updateGender={this.updateGender}
                        updateDateOfBirth={this.updateDateOfBirth}
                        updateAddress={this.updateAddress}
                        updateCity={this.updateCity}
                        updateProvinceState={this.updateProvinceState}
                        updateCountry={this.updateCountry}
                        updatePostalZipCode={this.updatePostalZipCode}
                        updateSignForChildren={this.updateSignForChildren}
                        handleClickBack={this.onClickBack}
                        handleClickNext={this.onClickNext}
                        adultYearOfBirthTried={this.state.adultYearOfBirthTried}
                        adultMonthOfBirthTried={this.state.adultMonthOfBirthTried}
                        adultDayOfBirthTried={this.state.adultDayOfBirthTried}
                        updateYearOfBirthTried={this.updateYearOfBirthTried}
                        updateMonthOfBirthTried={this.updateMonthOfBirthTried}
                        updateDayOfBirthTried={this.updateDayOfBirthTried}
                    />
                );
            case WaiverPage.ChildInformation:
                addCustomTagEvent({
                    event: 'pageView',
                    page: {
                        path: "/waiver/ChildInformation"
                    }
                });
                return (
                    <ChildInformation
                        childrenInfo={this.state.childInfos}
                        updateChildrenInfo={this.updateChildrenInfo}
                        handleClickBack={this.onClickBack}
                        handleClickNext={this.onClickNext}
                    />
                );
            case WaiverPage.LocationSelection:
                addCustomTagEvent({
                    event: 'pageView',
                    page: {
                        path: "/waiver/LocationSelection"
                    }
                });
                return (
                    <LocationSelection
                        location={this.state.location}
                        locationsData={this.state.locationsData}
                        updateLocation={this.updateLocation}
                        handleClickBack={this.onClickBack}
                        handleClickNext={this.onClickNext}
                    />
                );
            case WaiverPage.HearAbout:
                // ReactGA.pageview("/waiver/HearAbout");
                return (
                    <HearAbout
                        selectedLocationName={this.state.locationsData[this.state.location].displayName}
                        updateHearAbout={this.updateHearAbout}
                        updateOtherEntry={this.updateOtherEntry}
                        hearAbout={this.state.hearAbout}
                        otherEntry={this.state.otherEntry}
                        hearAboutData={this.state.hearAboutData}
                        handleClickBack={this.onClickBack}
                        handleClickNext={this.onClickNext}
                    />
                );
            case WaiverPage.Agreement:
                addCustomTagEvent({
                    event: 'pageView',
                    page: {
                        path: "/waiver/Agreement"
                    }
                });
                return (
                    <div className="Agreement">
                        <Agreement
                            checkedTerms={this.state.checkedTerms}
                            checkedRules={this.state.checkedRules}
                            checkedRelease={this.state.checkedRelease}
                            checkedNewsletter={this.state.checkedNewsletter}
                            checkedSmsOptIn={this.state.checkedSmsOptIn}
                            updateCheckTerms={this.updateCheckTerms}
                            updateCheckRules={this.updateCheckRules}
                            updateCheckRelease={this.updateCheckRelease}
                            updateCheckNewsletter={this.updateCheckNewsletter}
                            updateCheckSmsOptIn={this.updateCheckSmsOptIn}
                            updateReCaptcha={this.updateReCaptcha}
                            handleClickBack={this.onClickBack}
                            handleClickNext={this.onClickNext}
                            hasChildren={this.state.childInfos[0].firstName ? true : false}
                        />
                    </div>
                );
            /* eslint-disable*/
            case WaiverPage.Completed:
                // ReactGA.pageview("/waiver/Completed");
                // return (
                //     <Completed />
                // );
            default:
            /* eslint-enable */
                // ReactGA.pageview("/waiver/default");
                // return (<div>{this.state.currentPage === undefined}</div>);
                addCustomTagEvent({
                    event: 'pageView',
                    page: {
                        path: "/waiver/Completed"
                    }
                });
                return (
                    <Completed />
                );
        }
    };

    render() {
        return (
            <div className={'OnlineWaiver'}>
                <div className={'OnlineWaiver-content'}>
                    <div className={'OnlineWaiver-header'}>
                        <div className={'OnlineWaiver-header-title'}>
                            {/* {'Ctrl V Terms and Conditions Waiver'} */}
                            {<Translate id="waiver_title" />}
                        </div>
                        {this.state.currentPage !== WaiverPage.Completed && (
                            <div className={'OnlineWaiver-header-required'}>
                                {<Translate id="online_waiver_js.header_required"/>}
                            </div>
                        )}
                    </div>
                    <LanguageToggle />
                    {this.getPage()}
                    <ToastContainer />
                </div>
            </div>
        );
    };
}

export default withLocalize(OnlineWaiver);

export {preFilled};
